import React, { useContext } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { UserContext } from "../../UserContext";
export default function Magazine(props) {
  return (
    <Box
      style={{ width: "180px", height: "350px", borderRadius: "10px" }}
      component="fieldset"
      borderColor="gray"
      marginTop="40px"
    >
      <Typography component="legend">
        <b style={{ fontSize: "12px" }}>Read More</b>
      </Typography>

      <div className={props.id}></div>
      <p style={{ marginTop: "20px" }}>
        <b>{props.name}</b>
      </p>
      <p>
        <b>{props.description}</b>
      </p>

      <p style={{ fontSize: "10px" }}>
        <b>{props.date}</b>
      </p>
    </Box>
  );
}
